import { MyApprovalsPage } from '@/components/approvals/my-approvals-page'

export function OperationsApprovals() {
  return <MyApprovalsPage />
}
